import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

import type { Employees } from 'modules/employees/store/collections/employees'
import Settings from 'modules/surveys/components/Participants/Table/Body/BodyLayout/Settings'
import { AccessGroupTableContext } from 'modules/surveys/components/Participants/Table/context'
import EmployeeLabel from 'modules/surveys/components/Participants/common/EmployeeLabel'
import Location from 'modules/surveys/components/Participants/common/Location'
import { SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS } from 'modules/surveys/lib/constants'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'

interface Props {
  users: User[]
  employees: Employees
}

export default function BodyLayout({ users, employees }: Props) {
  const loading = React.useContext(AccessGroupTableContext)
  const { form } = useSurveyShowContext()
  const isAnonymous = form?.isAnonymous
  const hasEnoughUsers = users.length > SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS

  return (
    <Table.Body>
      {loading && <Table.Loading colSpan={3} />}
      {!loading && (
        <>
          {users.length === 0 && (
            <Table.Blank colSpan={5} text={i18n.t('surveys.index.table.body.no_participants')} />
          )}
          {users.map((user) => (
            <Table.Row key={user.attributes.id}>
              <Table.Cell>
                <EmployeeLabel user={user} />
              </Table.Cell>
              <Table.Cell>
                <Location user={user} employees={employees} />
              </Table.Cell>
              <Table.Cell>
                <Settings user={user} canHaveSettings={isAnonymous ? hasEnoughUsers : true} />
              </Table.Cell>
            </Table.Row>
          ))}
        </>
      )}
    </Table.Body>
  )
}
